import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { IMapLocation } from "../../interfaces/map-location";
import SiteStats from "../../ui-elements/site-stats/site-stats";

interface IProps {
  locations: IMapLocation[];
  selectedSite?: {
    latitude: number;
    longitude: number;
    address: string;
    value: number;
  };
  height?: number;
  fullscreenControl?: boolean;
  zoomControl?: boolean;
  cameraControl?: boolean;
  keyboardShortcuts?: boolean;
}

const initialCenter = {
  lat: 6.9271,
  lng: 79.8612,
};

const GoogleMapDetails = (props: IProps) => {
  const {
    locations,
    selectedSite,
    height = 550,
    fullscreenControl = true,
    zoomControl = true,
    cameraControl = true,
    keyboardShortcuts = true,
  } = props;
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAk0zO9xM7dkjY75FqH_wwqK092AtAytBA",
    libraries: ["places"],
  });

  const containerStyle = {
    width: "100%",
    height: `${height}px`,
    borderRadius: "8px",
    border: "1px solid #1A3C84",
    boxShadow: "0px 0px 4px 0px #00000040 inset",
  };

  const [mapCenter, setMapCenter] = useState(
    locations.length > 0 ? locations[0] : initialCenter
  );
  const [selectedLocation, setSelectedLocation] = useState<IMapLocation | null>(
    null
  );

  useEffect(() => {
    if (selectedSite) {
      setMapCenter({
        lat: selectedSite.latitude,
        lng: selectedSite.longitude,
      });
    }
  }, [selectedSite]);

  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          zoom={10}
          options={{
            fullscreenControl: fullscreenControl,
            zoomControl: zoomControl,
            cameraControl: cameraControl,
            keyboardShortcuts: keyboardShortcuts,
          }}
        >
          {locations.map((location, index) => (
            <Marker
              key={index}
              position={location}
              onClick={() => setSelectedLocation(location)}
            />
          ))}
          {selectedLocation && selectedSite && (
            <InfoWindow
              position={selectedLocation}
              onCloseClick={() => setSelectedLocation(null)}
            >
              <div className="d-flex align-items-center gap-2">
                <div className="text-dark font-size-14 font-weight-500">
                  {selectedSite.address}
                </div>
                <div>
                  <SiteStats value={selectedSite.value} />
                </div>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </>
  );
};

export default GoogleMapDetails;
